import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "customer-bottom-nav",
  "data-testid": "nav-bottom"
}
const _hoisted_2 = { class: "bottom-nav-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.showHomeDesigns)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["bottom-nav-btn", { active: $setup.isHomeActive }]),
            type: "button",
            "aria-label": "Home Designs",
            "data-testid": "nav-bottom-home",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.onNavigate('browse')))
          }, [
            _createVNode($setup["Home"], { size: 20 }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Home Designs", -1))
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: _normalizeClass(["bottom-nav-btn", { active: $setup.isMapActive }]),
        type: "button",
        "aria-label": "Map",
        "data-testid": "nav-bottom-map",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.onNavigate('map')))
      }, [
        _createVNode($setup["Map"], { size: 20 }),
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Map", -1))
      ], 2)
    ])
  ]))
}